import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Checkbox,
  Text,
  VStack
} from '@chakra-ui/react'
import { FC } from 'react'

import { getFalhaDescricao } from '@helper/mrp/approval'

import { IPendingOrderItem } from '@base/@types/providers/Mrp/ApprovalProvider'

interface FalhasAlertProps {
  itens: IPendingOrderItem[]
  isChecked: boolean
  onChange: (checked: boolean) => void
  isDisabled?: boolean
}

// Lista de itens com falha + ciência obrigatória para aprovar o pedido
const FalhasAlert: FC<FalhasAlertProps> = ({
  itens,
  isChecked,
  onChange,
  isDisabled = false
}) => (
  <Alert status="warning" borderRadius="md" mt={3}>
    <AlertIcon />
    <Box flex="1">
      <AlertTitle>Itens com falha ({itens.length})</AlertTitle>
      <AlertDescription>
        <VStack align="start" spacing={1} mt={2}>
          {itens.map(item => (
            <Text key={item.id} fontSize="sm">
              • SKU {item.codigoMaterial} — {item.nomeMaterial}:{' '}
              {getFalhaDescricao(item)}
            </Text>
          ))}
        </VStack>
        <Checkbox
          mt={3}
          isChecked={isChecked}
          onChange={e => onChange(e.target.checked)}
          colorScheme="orange"
          isDisabled={isDisabled}
        >
          <Text fontSize="sm">
            Estou ciente das falhas e desejo prosseguir com o envio
          </Text>
        </Checkbox>
      </AlertDescription>
    </Box>
  </Alert>
)

export default FalhasAlert
